if ( document.body.classList.contains('post-type-archive-event')) {
    const articles = document.querySelectorAll('.archive-post-grid article')
    let timeoutHandler
    articles.forEach(article => article.addEventListener('mouseenter', e => {
        clearTimeout(timeoutHandler)

        const excerptHeight = e.target.querySelector('.event-excerpt').clientHeight
        const img = e.target.querySelector('img')
        const imgHeight = img.clientHeight
        img.style.height = imgHeight + excerptHeight + 'px'

      // set fixed height on card because of masonry grid
        e.target.style.height = e.target.clientHeight + 'px'
        e.target.classList.add('hover')
    }))
    articles.forEach(article => article.addEventListener('mouseleave', e => {
        e.target.querySelector('img').style.removeProperty('height')
        timeoutHandler = setTimeout(() => {
            e.target.classList.remove('hover')
        }, 200)
    timeoutHandler = setTimeout(() => {
        e.target.style.removeProperty('height')
      }, 1000)
    }))
}
